// redux/actions/desvinculaciones/types.js
export const FETCH_CONVENIOS_SUCCESS = "FETCH_CONVENIOS_SUCCESS";
export const FETCH_CONVENIOS_FAILURE = "FETCH_CONVENIOS_FAILURE";
export const FETCH_AUDIT_LOG_CONVENIOS_SUCCESS = "FETCH_AUDIT_LOG_CONVENIOS_SUCCESS";
export const FETCH_AUDIT_LOG_CONVENIOS_FAILURE = "FETCH_AUDIT_LOG_CONVENIOS_FAILURE";